document.addEventListener('DOMContentLoaded', function() {
  const slider = {
    wrapper: document.querySelector('.slider-wrapper'),
    slides: document.querySelectorAll('.slide'),
    prevButton: document.querySelector('.prev'),
    nextButton: document.querySelector('.next'),
    dotsContainer: document.querySelector('.dots-container'),
    
    state: {
      currentIndex: 0,
      touchStartX: 0,
      touchStartY: 0,
      touchEndX: 0,
      isHorizontalSwipe: false
    },

    init() {
      if (!this.wrapper || !this.slides.length) return;

      this.createDots();
      this.updateButtons();
      this.bindEvents();
    },

    createDots() {
      if (!this.dotsContainer) return;

      this.dotsContainer.innerHTML = '';
      this.slides.forEach((_, index) => {
        const dot = document.createElement('span');
        dot.classList.add('dot');
        dot.addEventListener('click', () => this.goToSlide(index));
        this.dotsContainer.appendChild(dot);
      });
      this.updateDots();
    },

    updateDots() {
      const dots = this.dotsContainer.querySelectorAll('.dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === this.state.currentIndex);
      });
    },

    updateButtons() {
      if (this.prevButton) {
        this.prevButton.classList.toggle('disabled', this.state.currentIndex === 0);
      }
      if (this.nextButton) {
        this.nextButton.classList.toggle('disabled', this.state.currentIndex === this.slides.length - 1);
      }
    },

    goToSlide(index) {
      if (index < 0 || index >= this.slides.length) return;

      this.state.currentIndex = index;
      this.wrapper.style.transform = `translateX(-${index * 100}%)`;
      this.updateButtons();
      this.updateDots();
      this.adjustNextButton();
    },

    moveSlide(direction) {
      const newIndex = this.state.currentIndex + direction;
      this.goToSlide(newIndex);
    },

    bindEvents() {
      // Touch events with modified handling
      this.wrapper.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
      this.wrapper.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
      this.wrapper.addEventListener('touchend', this.handleTouchEnd.bind(this));

      // Buttons
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.moveSlide(-1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.moveSlide(1));
      }

      // Resize
      window.addEventListener('resize', this.adjustNextButton.bind(this));
    },

    handleTouchStart(e) {
      // Reset swipe state
      this.state.isHorizontalSwipe = false;
      
      // Capture start coordinates
      const touch = e.touches[0];
      this.state.touchStartX = touch.clientX;
      this.state.touchStartY = touch.clientY;
    },

    handleTouchMove(e) {
      const touch = e.touches[0];
      const deltaX = touch.clientX - this.state.touchStartX;
      const deltaY = touch.clientY - this.state.touchStartY;
      
      // Determine if this is a horizontal or vertical movement
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
        // Prevent default only for significant horizontal swipes
        e.preventDefault();
        this.state.isHorizontalSwipe = true;
      }
    },

    handleTouchEnd(e) {
      // Only process horizontal swipes
      if (this.state.isHorizontalSwipe) {
        const touch = e.changedTouches[0];
        const deltaX = touch.clientX - this.state.touchStartX;
        
        // Swipe threshold
        if (Math.abs(deltaX) > 50) {
          deltaX > 0 ? this.moveSlide(-1) : this.moveSlide(1);
        }
      }
      
      // Reset swipe state
      this.state.isHorizontalSwipe = false;
    },

    adjustNextButton() {
      const currentSlide = this.slides[this.state.currentIndex];
      const textContent = currentSlide.querySelector('.text-content');
      const nextButton = this.nextButton;
      const dotsContainer = this.dotsContainer;
      const sliderContainer = document.querySelector('.slider-container');
      
      if (textContent && nextButton && sliderContainer) {
        const textWidth = textContent.offsetWidth;
        const containerWidth = sliderContainer.offsetWidth;
        
        const newPosition = Math.min(textWidth - 80, containerWidth - 80);
        nextButton.style.left = `${newPosition}px`;
        
        if (dotsContainer) {
          dotsContainer.style.width = `${textWidth}px`;
        }
      }
    }
  };

  slider.init();

  const textContentBlocks = document.querySelectorAll('.text-content');
const maxMinHeight = Math.max(...Array.from(textContentBlocks, block => parseFloat(getComputedStyle(block).minHeight) || 0));

textContentBlocks.forEach(block => {
  block.style.minHeight = `${maxMinHeight}px`;
});

console.log(`Set min-height to ${maxMinHeight}px for all .text-content elements.`);

  
});